import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../ui-custom/Reveal";
import GlowBackdrop from "../ui-custom/GlowBackdrop";

const ContactCTA = () => {
  return (
    <section className="relative py-24 md:py-32 px-6 overflow-hidden">
      <GlowBackdrop variant="section" />
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <Reveal>
          <span className="section-eyebrow mb-4 block">Let&rsquo;s Do It Together</span>
          <h2 className="font-display font-bold uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl text-foreground leading-tight mb-6">
            Ready To Power What&rsquo;s Next?
          </h2>
          <p className="text-muted-foreground text-base md:text-lg max-w-2xl mx-auto mb-10">
            Speak with our engineering and business development team about your grid connectivity, HVDC or
            FACTS project requirements.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contact" className="btn-glow-primary px-8 py-3.5 rounded-md font-semibold tracking-wide inline-flex items-center gap-2">
              Get In Touch <ArrowRight size={18} />
            </Link>
            <Link to="/power-products" className="btn-outline-glow px-8 py-3.5 rounded-md font-semibold tracking-wide">
              View Products
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ContactCTA;
